'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { Suspense } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { parseAsString, useQueryStates } from 'nuqs';
const tabs = {
  description: 'Description',
  specifications: 'Specifications',
  'external-features': 'External Features',
  'internal-features': 'Internal Features'
} as const;
export type VehicleSpecsTab = keyof typeof tabs;
export type VehicleSpecsTabLabel = (typeof tabs)[keyof typeof tabs];
const tabMap = Object.entries(tabs) as [[VehicleSpecsTab, VehicleSpecsTabLabel]];
function a11yProps(name: string) {
  return {
    id: `vehicle-tabs-${name}`,
    'aria-controls': `vehicle-tabs-${name}`,
    value: name
  };
}
export type VehicleSpecsTabSelectorProps = {
  onChange: (tab: VehicleSpecsTab) => void;
};
export function VehicleSpecsTabSelector(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <VehicleSpecsTabSelectorStatic />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Suspense fallback={t0}><VehicleSpecsTabSelectorDynamic {...props} /></Suspense>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function VehicleSpecsTabSelectorDynamic(t0) {
  const $ = _c(7);
  const {
    onChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      tab: parseAsString.withDefault("description")
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [queryParams, setQueryParams] = useQueryStates(t1);
  let t2;
  if ($[1] !== onChange || $[2] !== setQueryParams) {
    t2 = function handleChange(newValue) {
      setQueryParams({
        tab: newValue
      });
      onChange(newValue);
    };
    $[1] = onChange;
    $[2] = setQueryParams;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleChange = t2;
  const t3 = queryParams.tab as VehicleSpecsTab;
  let t4;
  if ($[4] !== handleChange || $[5] !== t3) {
    t4 = <VehicleSpecsTabSelectorStatic onChange={handleChange} value={t3} />;
    $[4] = handleChange;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function VehicleSpecsTabSelectorStatic(t0) {
  const $ = _c(7);
  const {
    onChange,
    value: t1
  } = t0;
  const value = t1 === undefined ? "description" : t1;
  let t2;
  if ($[0] !== onChange) {
    t2 = function handleChange(_event, newValue) {
      onChange?.(newValue);
    };
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleChange = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      borderBottom: 1,
      borderColor: "divider"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = tabMap.map(_temp);
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== handleChange || $[5] !== value) {
    t5 = <Box sx={t3}><Tabs value={value} onChange={handleChange} aria-label="Vehcile details">{t4}</Tabs></Box>;
    $[4] = handleChange;
    $[5] = value;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
function _temp(t0) {
  const [name, label] = t0;
  return <Tab key={name} label={label} {...a11yProps(name)} />;
}